import {
  cryptoUint32,
  sample,
  type Uint32Source,
} from "@/lib/tool-kit/random-fun/rng";

/** The list without repeated entries, first occurrence kept, order preserved. */
export function uniqueWords(words: readonly string[]): string[] {
  return [...new Set(words)];
}

/**
 * `count` different words from the pool, uniformly. The pool is de-duplicated first, so a
 * word that sits on two lists (a noun and a verb) is one entry: it can't appear twice in a
 * batch, and every word is equally likely.
 */
export function sampleWords(
  pool: readonly string[],
  count: number,
  source: Uint32Source = cryptoUint32
): string[] {
  return sample(uniqueWords(pool), count, source);
}
